import React, { useState, useRef, useEffect } from 'react';
import {
    Button, Tooltip, TextField, Typography,
    Dialog, DialogActions, DialogContent, DialogTitle
} from '@material-ui/core';
import axios from 'axios';

function RenaiEventAttendanceButton({ page, mini, onSubmitAtendance }) {
    const [attended, setAttended] = useState(page.extensionData.AttendanceData || false);
    const [modalOpen, setModalOpen] = useState(false);

    const onClick = () => {
        if (!attended) {
            setModalOpen(true);
        }
    };

    const onClose = () => {
        setModalOpen(false);
    };

    const onSubmit = () => {
        setModalOpen(false);
        setAttended(true);
        onSubmitAtendance?.();
    };

    useEffect(() => {
        setAttended(page.extensionData.AttendanceData || false);
    }, [page]);

    return <>
        <Button size="small" style={mini ? { padding: '4px', margin: 0, minWidth: 'auto', fontSize: '0.8rem' } : {}} variant="contained" color="primary" disabled={attended} onClick={onClick}>{attended ? 'Attended' : 'Record attendance'}</Button>
        <RenaiEventAttendanceForm isOpen={modalOpen} page={page} onClose={onClose} onSubmit={onSubmit} />
    </>;
}

function RenaiEventAttendanceForm({ isOpen, page, onClose, onSubmit }) {
    const textarea = useRef(null);
    const [error, setError] = useState(null);

    const handleSubmit = () => {
        setError(null);
        axios.post("api/pages/recordattendance/" + page.family, { reflection: textarea.current.value }, { withCredentials: true })
            .then(() => {
                onSubmit?.();
            })
            .catch(e => {
                console.log(e.response);
                setError(e.response.data.errors.reflection);
            });
    };

    return <Dialog open={isOpen} onClose={onClose} aria-labelledby={"renai-attend-dialog-title"+page.id}>
        <DialogTitle aria-labelledby={"renai-attend-dialog-title" + page.id}>Attendance</DialogTitle>
        <DialogContent>
            <Typography variant="body1">Please submit your reflection on your attendance to this event !TODO!</Typography>
            <TextField inputRef={textarea}
                id={"renai-attend-content" + page.id}
                label="Reflection"
                multiline
                rows={4}
                defaultValue=""
                variant="outlined"
                fullWidth
                error={!!error}
                helperText={error}
            />
        </DialogContent>
        <DialogActions>
            <Button onClick={handleSubmit} color="primary">Submit</Button>
            <Button onClick={onClose} color="default">Cancel</Button>
        </DialogActions>
    </Dialog>;
}

export default RenaiEventAttendanceButton;

export { RenaiEventAttendanceButton, RenaiEventAttendanceForm };